<template>
  <div class="mx-2 px-1">
    <custom-separator
      :text="$t('ListOfRequests')"
      class="case-separator py-3"
    />
    <request-row
      v-for="(item, index) in items"
      :key="`request-item-${index}`"
      :data="item"
      @on-go-to-request="onGoToRequestHandler"
    />
  </div>
</template>

<script>
//components lib
import CustomSeparator from 'custom-separator';

//components
import RequestRow from './RequestRow';

//constants
const EDIT_REQUEST_ROUTE_NAME = 'editRequest';

export default {
  name: 'RequestList',
  components: {
    CustomSeparator,
    RequestRow,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onGoToRequestHandler(businessId) {
      this.$router.push({
        name: EDIT_REQUEST_ROUTE_NAME,
        params: {
          businessId,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/custom-separator/index.scss';
</style>
